import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card, CardText} from 'material-ui/Card';
import compose from 'recompose/compose';
import inflection from 'inflection';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import PageDescription from '../components/PageDescription';
import {
    crudGetOne as crudGetOneAction,
    crudUpdate as crudUpdateAction
} from '../admin/dataActionsWithType';
import DefaultActions from 'admin-on-rest/lib/mui/detail/EditActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

export class EditWithType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key: 0,
            record: props.data,
        };
        this.previousKey = 0;
    }

    componentDidMount() {
        this.updateData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            this.setState({record: nextProps.data});
            if (this.fullRefresh) {
                this.fullRefresh = false;
                this.setState({key: this.state.key + 1});
            }
        }
        if (
            this.props.id !== nextProps.id ||
            this.props.type !== nextProps.type ||
            nextProps.version !== this.props.version
        ) {
            this.updateData(nextProps.resource, nextProps.type, nextProps.id);
        }
    }

    componentWillUnmount() {
    }

    getBasePath() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -1)
            .join('/');
    }

    getBasePathUpOne() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -2)
            .join('/');
    }

    /**
     * Redirect to this Product Unit's Product Show view
     *
     * @return {string}
     */
    defaultRedirectRoute() {
        let redirect = '/Products';
        if (this.props.data) {
            redirect = '/Products/'
                + encodeURIComponent(this.props.data.type) + '/'
                + encodeURIComponent(this.props.data.product_id) + '/show';
        }
        return redirect;
    }

    updateData(resource = this.props.resource, type = this.props.type, id = this.props.id) {
        this.props.crudGetOne(resource, type, id, this.getBasePath());
    }

    save = (record, redirect) => {
        this.props.crudUpdate(
            this.props.resource,
            this.props.type,
            this.props.id,
            record,
            this.props.data,
            this.getBasePathUpOne(),
            redirect
        );
    };

    render() {
        const {
            actions = <DefaultActions/>,
            children,
            data,
            desc,
            hasDelete,
            hasShow,
            hasList,
            id,
            isLoading,
            resource,
            title,
            translate,
            version,
        } = this.props;

        if (!children) return null;

        const basePath = this.getBasePath();

        const resourceName = translate(`resources.${resource}.name`, {
            smart_count: 1,
            _: inflection.humanize(inflection.singularize(resource)),
        });
        const defaultTitle = translate('aor.page.edit', {
            name: `${resourceName}`,
            id,
            data,
        });
        const titleElement = data ? (
            <Title title={title} record={data} defaultTitle={defaultTitle}/>
        ) : (
            ''
        );
        const descriptionElement = data ? (
            <PageDescription record={data} desc={desc}/>
        ) : (
            ''
        );

        return (
            <div className="edit-page">
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    {actions &&
                    React.cloneElement(actions, {
                        basePath,
                        data,
                        hasDelete,
                        hasShow,
                        hasList,
                        resource,
                    })}
                    <ViewTitle title={titleElement}/>
                    {descriptionElement}
                    {data ? (
                        React.cloneElement(children, {
                            save: this.save,
                            resource,
                            basePath,
                            record: data,
                            translate,
                            version,
                            redirect:
                                typeof children.props.redirect === 'undefined'
                                    ? this.defaultRedirectRoute()
                                    : children.props.redirect,
                        })
                    ) : (
                        <CardText>Loading</CardText>
                    )}
                </Card>
            </div>
        );
    }
}

EditWithType.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.node,
    crudGetOne: PropTypes.func.isRequired,
    crudUpdate: PropTypes.func.isRequired,
    data: PropTypes.object,
    desc: PropTypes.any,
    hasDelete: PropTypes.bool,
    hasShow: PropTypes.bool,
    hasList: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func,
    type: PropTypes.string,
    version: PropTypes.number.isRequired,
};

function mapStateToProps(state, props) {
    let resource = state.admin.resources[props.resource];
    return {
        id: decodeURIComponent(props.match.params.id),
        type: decodeURIComponent(props.match.params.type),
        data: resource ? resource.data[decodeURIComponent(props.match.params.id)] : null,
        isLoading: state.admin.loading > 0,
        version: state.admin.ui.viewVersion,
    };
}

const enhance = compose(
    connect(mapStateToProps, {
        crudGetOne: crudGetOneAction,
        crudUpdate: crudUpdateAction,
    }),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(EditWithType);



// WEBPACK FOOTER //
// ./src/Fuse/admin/CreateEditProductUnit.js